import React, { useEffect } from "react";
import { connect } from "react-redux";
import "./Services.scss";

import { useNavigate } from "react-router-dom";

import { Button } from "@chakra-ui/react";
import {
  EmailIcon,
  ArrowForwardIcon,
  InfoOutlineIcon,
  ArrowRightIcon,
} from "@chakra-ui/icons";

const SERVICES = [
  {
    id: "SOFTWARE_DEVELOPMENT",
    type: "software-development",
    title: `Software Development Staffing Solutions & Services`,
    desc: `Nothing transfers, captures, communicates, or moves without software developers & engineers doing what they do best. At Workoza, our hiring managers know software development isn’t a commodity. It’s a central function that cultivates innovation and crystallizes differentiation. That’s why we take so much care to find the best developers for your environment.`,
    img: `/software_development.jpeg`,
    imgAlt: `Software Development`,
  },
  {
    id: "PROJECT_MANAGEMENT",
    type: "project-management",
    title: `Project Management Recruitment Solutions`,
    desc: `Like other information technology disciplines, project management is no longer bound to the confines of four office walls. Today’s project managers are adept at collaborating with digital and remote teams and at applying hybrid methodologies to keep initiatives on track and within budget. Workoza excels at recruiting and retaining these world class multi-tasking masters.`,
    img: `/project_management.jpeg`,
    imgAlt: `Project Management`,
  },

  {
    id: "DATA_ANALYST",
    type: "data-analyst",
    title: `Data & Analytics Staffing Services`,
    desc: `Today, data and analytics and visualization touch every department and function. Whether you’re mining sales trends or tracking logistics across the supply chain, you need your data more accessible, understandable, and actionable. Workoza is right in the thick of it. `,
    img: `/data_analyst.jpeg`,
    imgAlt: `Data & Analytics`,
  },
  {
    id: "QUALITY_ASSURANCE",
    type: "quality-assurance",
    title: `Quality Assurance Staffing Agency`,
    desc: `A trend to test earlier and more often in the development cycle—”shifting left”—places increasing pressure on the talent market for quality assurance (QA) expertise. Workoza helps you get ahead of evolving tools and technology and keep pace with faster output demands. `,
    img: `/quality_assurance.jpeg`,
    imgAlt: `Quality Assurance`,
  },
];

const Services = (props) => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const navigate = useNavigate();

  const handleContactUsClick = () => {
    navigate("/contact-us");
  };

  const renderServicesTopbar = () => {
    return (
      <div className="servicesTopBarContainer">
        <div className="servicesTopBarMainText">
          The perfect place to find IT talent?
        </div>
        <div className="servicesTopBarMainSubText">
          Workoza is a boutique IT Service provider, providing a full range of
          IT services and solutions. We equally serve large, medium and small
          enterprises and allow our clients to experience excellence.
        </div>
        <div>
          <Button
            leftIcon={<EmailIcon />}
            rightIcon={<ArrowForwardIcon />}
            onClick={handleContactUsClick}
            colorScheme="red"
            size="lg"
          >
            Contact us
          </Button>
        </div>
      </div>
    );
  };

  const renderServicesFeed = () => {
    return SERVICES.map((service) => {
      const { id, type, title, desc, img, imgAlt } = service;
      const handleLearnMoreClick = () => {
        navigate(`/services/${type}`);
      };

      return (
        <div className="servicesWrapper" key={id}>
          <div className="servicesFeedImageContainer">
            <img src={img} alt={imgAlt} />
          </div>
          <div className="servicesFeedTextContainer">
            <div className="servicesFeedHeadText">{title}</div>
            <div className="servicesFeedSubText">{desc}</div>
            <div className="servicesFeedLearnMoreButton">
              <Button
                colorScheme="gray"
                variant="solid"
                leftIcon={<InfoOutlineIcon boxSize={4} />}
                rightIcon={<ArrowRightIcon boxSize={3} />}
                onClick={handleLearnMoreClick}
              >
                Learn more
              </Button>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="servicesContainer">
      {renderServicesTopbar()}
      {renderServicesFeed()}
    </div>
  );
};

const mapActionCreators = {
  // goToRelativeRoute,
};

export default connect(null, mapActionCreators)(Services);
